import React from "react"
import { useRouter } from "next/router"

import Layout from "~/components/Pages/Basic"
import { STATES, STATE_GENERAL_MAP, INFORMATION_BASE_PATH } from "~/components/traffic-tickets/information/constants"
import TrafficInformation from "~/components/traffic/information/Local"


const GeneralStateInformation = () => {
  const router = useRouter();
  if (!router.query || !router.query.state || !STATES[router.query.state]) {
    if (process.browser) router.replace(INFORMATION_BASE_PATH)
    return <Layout>Not Found</Layout>
  }
  if (!router.query.generalSlug || !STATE_GENERAL_MAP[router.query.state] || !STATE_GENERAL_MAP[router.query.state][router.query.generalSlug]) {
    if (process.browser) router.replace(`${INFORMATION_BASE_PATH}/${router.query.state}`);
    return <Layout>Not Found</Layout>
  }
  const generalItem = STATE_GENERAL_MAP[router.query.state][router.query.generalSlug];
  const state = STATES[router.query.state]
  return (
    <TrafficInformation
      title={generalItem.title}
      state={state}
      description={generalItem.description}
      content={generalItem.content}
    />
  )
}

export default GeneralStateInformation
